import { Link } from 'react-router'

import { CLIENTE_PADRAO } from '@/tenant/clientesStub'

/**
 * 404 — rendered INSIDE the shell, so a mistyped URL leaves the user somewhere they
 * can navigate out of rather than on a blank page.
 */
export function NaoEncontrado() {
  return (
    <div className="flex min-w-0 flex-1 flex-col items-start gap-4 p-8">
      <h1 className="type-h2 text-text-primary">Página não encontrada</h1>
      <p className="type-body-lg text-text-body max-w-xl">
        O endereço acessado não corresponde a nenhuma tela da plataforma.
      </p>
      <Link
        to={`/cliente/${CLIENTE_PADRAO}/finops/dashboard`}
        className="rounded-control bg-action-primary text-action-primary-fg hover:bg-action-primary-hover px-6 py-3 type-button transition-colors duration-base ease-out"
      >
        ir para o dashboard
      </Link>
    </div>
  )
}
